/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseDataResponse_ReferralApplicationFileUrlResponse_ } from '../models/BaseDataResponse_ReferralApplicationFileUrlResponse_';
import type { BaseDataResponse_ReferralApplicationResponse_ } from '../models/BaseDataResponse_ReferralApplicationResponse_';
import type { BaseDataResponse_UploadResumeResponse_ } from '../models/BaseDataResponse_UploadResumeResponse_';
import type { BaseListDataResponse_ReferralApplicationResponse_ } from '../models/BaseListDataResponse_ReferralApplicationResponse_';
import type { Body_upload_my_resume_api_hiring_referrals_upload_temp_resume_post } from '../models/Body_upload_my_resume_api_hiring_referrals_upload_temp_resume_post';
import type { CreateUserReferralApplicationRequest } from '../models/CreateUserReferralApplicationRequest';
import type { ReferralApplicationStatus } from '../models/ReferralApplicationStatus';
import type { UpdateReferralApplicationStatusRequest } from '../models/UpdateReferralApplicationStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HiringReferralsService {
    /**
     * List Referral Applications
     * Получение списка заявок реферальной программы с фильтрацией
     * @param status Фильтр по статусу
     * @param userId Фильтр по ID пользователя
     * @param userSearch Поиск по username, email или full_name (частичное совпадение)
     * @param candidateName Фильтр по имени кандидата (частичное совпадение)
     * @param directionId Фильтр по ID направления
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listReferralApplicationsApiHiringReferralsGet(
        status?: (ReferralApplicationStatus | null),
        userId?: (string | null),
        userSearch?: (string | null),
        candidateName?: (string | null),
        directionId?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/referrals',
            query: {
                'status': status,
                'user_id': userId,
                'user_search': userSearch,
                'candidate_name': candidateName,
                'direction_id': directionId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Upload My Resume
     * Загрузка файла резюме во временное хранилище
     * @param formData
     * @returns BaseDataResponse_UploadResumeResponse_ Successful Response
     * @throws ApiError
     */
    public static uploadMyResumeApiHiringReferralsUploadTempResumePost(
        formData: Body_upload_my_resume_api_hiring_referrals_upload_temp_resume_post,
    ): CancelablePromise<BaseDataResponse_UploadResumeResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiring/referrals/upload-temp-resume',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Create My Referral Application
     * Создание заявки на участие в реферальной программе от имени текущего пользователя
     * @param requestBody
     * @returns BaseDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static createMyReferralApplicationApiHiringReferralsMePost(
        requestBody: CreateUserReferralApplicationRequest,
    ): CancelablePromise<BaseDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/hiring/referrals/me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * List My Referral Applications
     * Получение своих заявок на участие в реферальной программе
     * @param status Фильтр по статусу
     * @param limit Лимит
     * @param offset Смещение
     * @returns BaseListDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static listMyReferralApplicationsApiHiringReferralsMeGet(
        status?: (ReferralApplicationStatus | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BaseListDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/referrals/me',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Code: authentication_error`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get My Referral Application
     * Получение своей заявки на участие в реферальной программе по ID
     * @param applicationId
     * @returns BaseDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyReferralApplicationApiHiringReferralsMeApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/referrals/me/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: referral_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Referral Application
     * Получение заявки реферальной программы по ID
     * @param applicationId
     * @returns BaseDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static getReferralApplicationApiHiringReferralsApplicationIdGet(
        applicationId: string,
    ): CancelablePromise<BaseDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/referrals/{application_id}',
            path: {
                'application_id': applicationId,
            },
            errors: {
                401: `Code: authentication_error`,
                404: `Code: referral_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Get Referral Application File Url
     * Получение временной ссылки на файл резюме заявки
     * @param applicationId
     * @param expiresIn Время действия ссылки в секундах
     * @returns BaseDataResponse_ReferralApplicationFileUrlResponse_ Successful Response
     * @throws ApiError
     */
    public static getReferralApplicationFileUrlApiHiringReferralsApplicationIdFileUrlGet(
        applicationId: string,
        expiresIn: number = 3600,
    ): CancelablePromise<BaseDataResponse_ReferralApplicationFileUrlResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/hiring/referrals/{application_id}/file-url',
            path: {
                'application_id': applicationId,
            },
            query: {
                'expires_in': expiresIn,
            },
            errors: {
                400: `Code: referral_application_not_file`,
                401: `Code: authentication_error`,
                404: `Code: referral_application_not_found`,
                422: `Validation Error`,
                500: `Code: internal_server_error`,
            },
        });
    }
    /**
     * Update Referral Application Status Endpoint
     * Обновление статуса заявки реферальной программы
     * @param applicationId
     * @param requestBody
     * @returns BaseDataResponse_ReferralApplicationResponse_ Successful Response
     * @throws ApiError
     */
    public static updateReferralApplicationStatusEndpointApiHiringReferralsApplicationIdStatusPut(
        applicationId: string,
        requestBody: UpdateReferralApplicationStatusRequest,
    ): CancelablePromise<BaseDataResponse_ReferralApplicationResponse_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/hiring/referrals/{application_id}/status',
            path: {
                'application_id': applicationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Code: authentication_error`,
                404: `Code: referral_application_not_found`,
                422: `Code: validation_error`,
                500: `Code: internal_server_error`,
            },
        });
    }
}
